import React from "react";
import '../App.css';
import './HeroSection.css';

export default function HeroSection() {
  return (
    <div className='hero-container'>
      <div className="hero-content">
        <h1>Otváracie hodiny</h1>
        
        <div className="glass-container">
          <table id="otvaracie-hod">
            <tbody>
              <tr>
                <td className="day">Pondelok</td>
                <td className="hours">11:00 - 22:00</td>
              </tr>
              <tr>
                <td className="day">Utorok</td>
                <td className="hours">11:00 - 00:00</td>
              </tr>
              <tr>
                <td className="day">Streda</td>
                <td className="hours">11:00 - 00:00</td>
              </tr>
              <tr>
                <td className="day">Štvrtok</td>
                <td className="hours">11:00 - 00:00</td>
              </tr>
              <tr>
                <td className="day">Piatok</td>
                <td className="hours">11:00 - 01:00</td>
              </tr>
              <tr>
                <td className="day">Sobota</td>
                <td className="hours">10:00 - 01:00</td>
              </tr>
              <tr>
                <td className="day">Nedeľa</td>
                <td className="hours">10:00 - 22:00</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="arrow-wrapper">
        <svg className="arrows">
            <path className="a1" d="M0 0 L30 32 L60 0"></path>
            <path className="a2" d="M0 20 L30 52 L60 20"></path>
            <path className="a3" d="M0 40 L30 72 L60 40"></path>
        </svg>
      </div>
    </div>
  );
};